import Component from "@ember/component"
import { action, set } from "@ember/object"
import { inject as service } from "@ember/service"
import { tracked } from "@glimmer/tracking"
import type { Card, CardStack } from "@shared/models/card-stack"
import type { Planbook } from "@shared/models/planbook"
import type EmberStore from "cc-frontend/services/ember-store"
import type RoutineEditor from "cc-frontend/services/routine-editor"

export default class RoutineNoteCard extends Component {
  // services
  @service("ember-store") store!: EmberStore
  @service routineEditor!: RoutineEditor

  menuConstraints = [{ to: "window", pin: ["left", "bottom"] }]

  // args
  card!: Card
  planbook!: Planbook
  routine!: CardStack
  dateString!: string

  // props
  @tracked deleteMenuIsOpen = false
  isHovering = false

  mouseEnter() {
    set(this, "isHovering", true)
  }

  mouseLeave() {
    set(this, "isHovering", false)
  }

  // actions
  @action
  updateValue(cardId, value) {
    this.routineEditor.editCardValue(
      { planbook: this.planbook, routine: this.routine, dateString: this.dateString },
      cardId,
      value
    )
  }

  @action
  finishedEditing(cardId, value) {
    this.routineEditor.finishEditingCardValue(
      { planbook: this.planbook, routine: this.routine, dateString: this.dateString },
      cardId,
      value,
      // @ts-ignore The problem is some types of cards don't have a value. Not sure how to fix this check
      this.card.attributes.value
    )
  }

  @action
  openDeleteMenu() {
    this.deleteMenuIsOpen = true
  }

  @action
  closeDeleteMenu() {
    this.deleteMenuIsOpen = false
  }

  @action
  removeSection(card) {
    this.deleteMenuIsOpen = false
    this.routineEditor.removeCard(
      { planbook: this.planbook, routine: this.routine, dateString: this.dateString },
      card
    )
  }
}
